/**
 * V3 Permission codes — mirrors backend PermissionCodes.cs exactly.
 * When a new permission is added to the backend, it must be added here too.
 */
export const PermissionCodesV3 = {
  Reviewer: {
    Domain: 'REVIEWER',
    Panel: {
      All: 'REVIEWER.PANEL',
      View: 'REVIEWER.PANEL.VIEW',
      Search: 'REVIEWER.PANEL.SEARCH',
      Filter: 'REVIEWER.PANEL.FILTER',
      Export: 'REVIEWER.PANEL.EXPORT',
      Report: 'REVIEWER.PANEL.REPORT',
      Columns: 'REVIEWER.PANEL.COLUMNS',
    },
    Profile: {
      All: 'REVIEWER.PROFILE',
      View: 'REVIEWER.PROFILE.VIEW',
      Create: 'REVIEWER.PROFILE.CREATE',
      Edit: 'REVIEWER.PROFILE.EDIT',
      ContactEdit: 'REVIEWER.PROFILE.CONTACT.EDIT',
      RatesEdit: 'REVIEWER.PROFILE.RATES.EDIT',
      InternalNoteEdit: 'REVIEWER.PROFILE.INTERNALNOTE.EDIT',
      PasswordReset: 'REVIEWER.PROFILE.PASSWORDRESET',
      Import: 'REVIEWER.PROFILE.IMPORT',
    },
    Status: {
      All: 'REVIEWER.STATUS',
      Invite: 'REVIEWER.STATUS.INVITE',
      Hold: 'REVIEWER.STATUS.HOLD',
      RemoveHold: 'REVIEWER.STATUS.REMOVE_HOLD',
      Archive: 'REVIEWER.STATUS.ARCHIVE',
      Reactivate: 'REVIEWER.STATUS.REACTIVATE',
      NotReady: 'REVIEWER.STATUS.NOTREADY',
      Discard: 'REVIEWER.STATUS.DISCARD',
      ContinueOnboarding: 'REVIEWER.STATUS.CONTINUEONBOARDING',
      Complete: 'REVIEWER.STATUS.COMPLETE',
      EditFollowUpDate: 'REVIEWER.STATUS.EDITFOLLOWUPDATE',
    },
    AuditHold: {
      All: 'REVIEWER.AUDITHOLD',
      View: 'REVIEWER.AUDITHOLD.VIEW',
      Manage: 'REVIEWER.AUDITHOLD.MANAGE',
    },
    Document: {
      All: 'REVIEWER.DOCUMENT',
      View: 'REVIEWER.DOCUMENT.VIEW',
      Upload: 'REVIEWER.DOCUMENT.UPLOAD',
      Edit: 'REVIEWER.DOCUMENT.EDIT',
      Delete: 'REVIEWER.DOCUMENT.DELETE',
      Download: 'REVIEWER.DOCUMENT.DOWNLOAD',
      Search: 'REVIEWER.DOCUMENT.SEARCH',
      Filter: 'REVIEWER.DOCUMENT.FILTER',
    },
    Note: {
      All: 'REVIEWER.NOTE',
      View: 'REVIEWER.NOTE.VIEW',
      Create: 'REVIEWER.NOTE.CREATE',
      Edit: 'REVIEWER.NOTE.EDIT',
      EditBody: 'REVIEWER.NOTE.EDITBODY',
      Delete: 'REVIEWER.NOTE.DELETE',
      Comment: 'REVIEWER.NOTE.COMMENT',
      EditComment: 'REVIEWER.NOTE.EDITCOMMENT',
      DeleteComment: 'REVIEWER.NOTE.DELETECOMMENT',
    },
    License: {
      All: 'REVIEWER.LICENSE',
      View: 'REVIEWER.LICENSE.VIEW',
      Manage: 'REVIEWER.LICENSE.MANAGE',
      ManagePrivileged: 'REVIEWER.LICENSE.MANAGEPRIVILEGED',
    },
    Certification: {
      All: 'REVIEWER.CERTIFICATION',
      View: 'REVIEWER.CERTIFICATION.VIEW',
      Manage: 'REVIEWER.CERTIFICATION.MANAGE',
      ManagePrivileged: 'REVIEWER.CERTIFICATION.MANAGEPRIVILEGED',
    },
    Unavailability: {
      All: 'REVIEWER.UNAVAILABILITY',
      Manage: 'REVIEWER.UNAVAILABILITY.MANAGE',
    },
    Self: {
      All: 'REVIEWER.SELF',
      View: 'REVIEWER.SELF.VIEW',
      Edit: 'REVIEWER.SELF.EDIT',
      DocumentUpload: 'REVIEWER.SELF.DOCUMENTUPLOAD',
    },
    ImeLocation: {
      All: 'REVIEWER.IMELOCATION',
      Manage: 'REVIEWER.IMELOCATION.MANAGE',
    },
  },
  Role: {
    Domain: 'ROLE',
    Panel: {
      All: 'ROLE.PANEL',
      View: 'ROLE.PANEL.VIEW',
    },
    Management: {
      All: 'ROLE.MANAGEMENT',
      View: 'ROLE.MANAGEMENT.VIEW',
      Create: 'ROLE.MANAGEMENT.CREATE',
      Edit: 'ROLE.MANAGEMENT.EDIT',
      Delete: 'ROLE.MANAGEMENT.DELETE',
    },
  },
} as const;
